import {
  Grid,
  Box,
  Typography,
  ThemeProvider,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";

import { createTheme } from "@mui/material/styles";
import Snackbars from "./Snackbars";
import CustomCardHeader from "./CustomCardHeaderL1";
import { StyledHr } from "./CustomDivider";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1e5d45", // Custom primary color
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: "#f44336", // Custom error color
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "@media (min-width:1200px)": {
          body: {
            fontSize: "12px", // Smaller font size for lg screens
          },
        },
        "@media (max-width:1199px)": {
          body: {
            fontSize: "14px", // Default font size for smaller screens
          },
        },
      },
    },
  },
  typography: {
    fontSize: 14,
    h6: {
      "@media (max-width:1199px)": {
        fontSize: "1rem", // Default font size for smaller screens
      },
    },
    body1: {
      fontSize: "0.875rem", // Default font size for body1
      "@media (min-width:1200px)": {
        fontSize: "1rem", // Larger font size for lg screens
      },
      "@media (max-width:1199px)": {
        fontSize: "0.875rem", // Default font size for smaller screens
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

// NOTE: This reusable component serves as a wrapper for CRUD routes (e.g., /create-service-report, /view-service-report,..) to provide a consistent layout and styling.

export const BaseFormWrapper = ({
  children,
  titleIcon,
  title,
  subTitle,
  subTitleRoute,
  formTitle,
  // NOTE: make sure to always pass these props below for snackbars to show
  successMessage,
  setSuccessMessage,
  errorMessage,
  setErrorMessage,
  isLoading,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <Snackbars
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        isLoading={isLoading}
      />

      <Card
        variant="outlined"
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          borderRadius: 0,
        }}
      >
        {/* NOTE: The CustomCardHeader includes the breadcrumbs component */}
        <CustomCardHeader
          titleIcon={titleIcon}
          title={title}
          subTitle={subTitle}
          subTitleRoute={subTitleRoute}
        />
        <CardContent sx={{ padding: { xs: "10px", md: "10px" } }}>
          <Card variant="outlined" sx={{ padding: { xs: "10px", md: "10px" } }}>
            <CardHeader sx={{
              paddingLeft: 0,
              paddingBottom: 0
            }}
              title={
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {formTitle}
                </Typography>
              }
            />

            <Grid item xs={12}>
              <StyledHr />
              {children}
            </Grid>
          </Card>
        </CardContent>
      </Card>
    </ThemeProvider>
  );
};

export default BaseFormWrapper;
